// extracted by mini-css-extract-plugin
module.exports = {"date":"ProcedureTableInfo_date__3ohX7","head":"ProcedureTableInfo_head__2tsBX"};